import { Controller } from "@hotwired/stimulus";

// Connects with data-controller="field-validator"
export default class extends Controller<HTMLInputElement> {
  declare errorElement: HTMLParagraphElement;

  validate() {
    const existingErrorElement =
      this.errorElement || document.getElementById(`${this.element.id}-error`);

    if (this.element.validity.valid) {
      if (existingErrorElement) {
        existingErrorElement.innerText = "";
      }
    } else {
      if (existingErrorElement) {
        existingErrorElement.innerText = this.element.validationMessage;
      } else {
        this.errorElement = document.createElement("p");
        this.errorElement.innerText = this.element.validationMessage;
        this.errorElement.classList.add("FormField__Error");
        this.errorElement.id = `${this.element.id}-error`;
        this.element.insertAdjacentElement("afterend", this.errorElement);
      }
    }
  }
}
